import {baseUrl, sortByFc} from '../../lib/';

export const saveItemToWP = async(data, type, title, authorId) => {
    const nonce = document.getElementById('wpRestNonce').value;
    const result = await fetch(`${baseUrl}/wp-json/wp/v2/${type}`, {
        method: 'POST',
        headers: {
            ...(nonce ? 
                {'X-WP-Nonce': nonce} :
                {'Authorization':`Basic ${btoa('guest:guest')}`}
            ),
            'Content-Type': 'application/json',
            //'X-WP-Nonce': window.wpApiSettings.nonce
        },
        body: JSON.stringify({
            title,
            status: 'publish',
            ...(authorId && {author: parseInt(authorId)} ),
            data,
            for_share: (authorId ? 0 : 1),
        }),
    });
    const json = await result.json();
    return json;
};

export const updateItemToWP = async(data, type, title, postId, authorId) => {
    const nonce = document.getElementById('wpRestNonce').value;
    const result = await fetch(`${baseUrl}/wp-json/wp/v2/${type}/${postId}`, {
        method: 'POST',
        headers: {
            'X-WP-Nonce': nonce,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            title,
            status: 'publish',
            author: parseInt(authorId),
            for_share: 0,
            data,
        }),
    });
    const json = await result.json();
    return json;
};

export const getPostsWP = async(userId, type) => {
    const result = await fetch(`${baseUrl}/wp-json/wp/v2/${type}?author=${userId}`, {
        headers: {
            'Authorization':`Basic ${btoa('guest:guest')}`,
            'Content-Type': 'application/json',
            //'X-WP-Nonce': window.wpApiSettings.nonce
        },
    });
    const json = await result.json();
    return json;
};

export const getPostWP = async(postId, type) => {
    const result = await fetch(`${baseUrl}/wp-json/wp/v2/${type}/${postId}`, {
        headers: {
            'Authorization':`Basic ${btoa('guest:guest')}`,
            'Content-Type': 'application/json',
            //'X-WP-Nonce': window.wpApiSettings.nonce
        },
    });
    const json = await result.json();
    return json;
};

export const getPlayersByYear = async(year) => {
    const result = await fetch(`${baseUrl}/wp-json/reports-builder/v1/players/?year=${year}`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    const json = await result.json();
    const sortedPlayers = json.map((p)=> ({...p, fcRank: p.fcRank === '0' ? 'N/A' : parseInt(p.fcRank) }) ).sort(sortByFc);
    return sortedPlayers;
};

export const getReportsByYear = async(year) => {
    // const nonce = document.getElementById('wpRestNonce').value;
    const scout = document.getElementById('scoutId').value;
    const result = await fetch(`${baseUrl}/wp-json/reports-builder/v1/reports/?year=${year}&scout=${scout}`);
    const json = await result.json();
    return json;
}

export const getReportById = async(reportId) => {
    const nonce = document.getElementById('wpRestNonce').value;
    const result = await fetch(`${baseUrl}/wp-json/reports-builder/v1/reports/${reportId}`, {
        method: 'GET',
        headers: {
            'X-WP-Nonce': nonce,
            'Content-Type': 'application/json',
        },
    });
    const json = await result.json();
    return json;
}

export const saveReport = async(data, status) => {
    const nonce = document.getElementById('wpRestNonce').value;
    const scoutId = document.getElementById('scoutId').value;
    const fullUserName = document.getElementById('fullUserName').value;
    const result = await fetch(`${baseUrl}/wp-json/reports-builder/v1/reports`, {
        method: 'POST',
        headers: {
            'X-WP-Nonce': nonce,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            title: data.title,
            scoutName: fullUserName,
            scoutId,
            status,
            data: {
                ...data,
                type: data.event === 'Summary' ? 'Draft Guide' : data.type,
            }
        }),
    });
    const json = await result.json();
    return json;
};

export const updateReport = async(data, status, reportID) => {
    const nonce = document.getElementById('wpRestNonce').value;
    const scoutId = document.getElementById('scoutId').value;
    const fullUserName = document.getElementById('fullUserName').value;
    const result = await fetch(`${baseUrl}/wp-json/reports-builder/v1/reports/${reportID}`, {
        method: 'PUT',
        headers: {
            'X-WP-Nonce': nonce,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            title: data.title,
            scoutName: fullUserName,
            scoutId,
            status,
            data: {
                ...data,
                type: data.event === 'Summary' ? 'Draft Guide' : data.type,
            }
        }),
    });
    const json = await result.json();
    return json;
};

export const deleteItem = async(postId, type) => {
    const nonce = document.getElementById('wpRestNonce').value;
    const result = await fetch(`${baseUrl}/wp-json/wp/v2/${type}/${postId}/?force=true`, {
        method: 'DELETE',
        headers: {
            'X-WP-Nonce': nonce,
            'Content-Type': 'application/json',
        }
    });
    const json = await result.json();
    return json;
}

export const submitMakeRequestForm = async(data) => {
    const nonce = document.getElementById('wpRestNonce').value;
    const result = await fetch(`${baseUrl}/wp-json/gf/v2/entries`, {
        method: 'POST',
        headers: {
            'X-WP-Nonce': nonce,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            form_id: 3,
            '2': data.requestName,
            '7': data.requestTeam,
            '5': data.requestLeague,
            '6': data.requestDetails
        })
    });
    const json = await result.json();
    return json;
}

export const sendRequestNotifications = async(entryId) => {
    const nonce = document.getElementById('wpRestNonce').value;
    const result = await fetch(`${baseUrl}/wp-json/gf/v2/entries/${entryId}/notifications`, {
        method: 'POST',
        headers: {
            'X-WP-Nonce': nonce,
            'Content-Type': 'application/json',
        }
    });
    const json = await result.json();
    return json;
}

export const getSponsors = async() => {
    const result = await fetch(`https://nhlentrydraft.com/wp-json/sponsors/v1/interactive`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    const json = await result.json();
    return json;
}